var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 135,
    viewBox: "0 0 136 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33482 3.4987L46.8836 2.30494C48.7355 2.25274 50.3605 3.65303 50.7486 5.63431L65.3643 80.3602C66.2584 84.9288 72.2726 84.7472 72.9353 80.131L83.7496 4.72197C84.0378 2.71345 85.5969 1.21557 87.4557 1.16337L128.888 0.00138336C131.014 -0.0576239 132.782 1.77841 132.837 4.10466L135.703 126.284C135.758 128.61 134.078 130.544 131.952 130.603L102.18 131.438C100.054 131.497 98.2858 129.661 98.2313 127.335L97.0239 75.8507C96.9037 70.767 90.1791 70.2246 89.3802 75.2357L80.8696 128.651C80.5541 130.628 79.0086 132.087 77.1748 132.139L62.5274 132.55C60.6981 132.602 59.0891 131.238 58.6783 129.291L47.2944 75.5693C46.2459 70.624 39.5735 71.5546 39.6938 76.6292L40.9216 128.944C40.9761 131.27 39.2966 133.204 37.1701 133.263L7.39866 134.098C5.27212 134.157 3.50418 132.321 3.44971 129.994L0.58332 7.81531C0.528851 5.48906 2.20829 3.55544 4.33482 3.49643V3.4987Z",
    fill: "#8ABEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLetter);
export default __webpack_public_path__ + "static/media/m-letter.16f5c29677ab4d54a6283324e7a84736.svg";
export { ForwardRef as ReactComponent };